import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    email: Yup.string().email().required('ایمیل اجباری است'),
})
